module.exports = __webpack_public_path__ + "static/media/IMG_0349.60638a8c.JPG";